import { useLayoutEffect } from 'react';
import { toast } from 'react-toastify';
import routes from '../../../../../Routes/routes';
import { errorMsg } from '../../../../../Apis/functions';
import { CreateShift } from '../../../../../reduxToolkit/FoodieShift/FoodieShiftApi';
import CommonShiftApp from './CommonShiftApp';
import { STEPS_CREATE_FOODIE_SHIFT } from '../Model/Models';
import { SUB_VIEW_MODEL, TABS_FOODIE } from "../../Model/Models";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Create-only hook. Builds the create stepper labels and submits the single
 * shift body (toRegister) once. Mirrors AttendanceShift AddShiftAccessApp.
 */
export const CreateShiftApp = () => {

    const {
        id,
        t,
        DEV,
        permission,
        dispatch,
        navigate,
        emptyFields,
        disabled,
        item,
        handleChange,
        validate,
        setSteps,

        cafeterias, setCafeterias,
        selectDeleteCafeterias, setSelectDeleteCafeterias,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,

        user, setUser,
        selectDeleteUser, setSelectDeleteUser,

        steps,
        activeStep, setActiveStep,
        searchElement, setSearchElement,
        modified, setModified,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleOnBack,
    } = CommonShiftApp();

    useLayoutEffect(() => {
        const stepArray = Object.values(STEPS_CREATE_FOODIE_SHIFT)
            .filter(step => step?.TRANS && typeof step.INDEX === "number")
            .sort((a, b) => a.INDEX - b.INDEX)
            .map(step => t(step.TRANS));
        setSteps(stepArray);
    }, [t]);

    /**
     * Validates, builds the shift body and creates it; on success notifies and
     * navigates back to the list.
     */
    const handleAddEdit = () => {
        if (!validate()) return;
        const body = item.toRegister(cafeterias, departments, user);
        dispatch(CreateShift(body)).then(({ payload: { data: { success, data, code } } }) => {
            if (success && data?.id) {
                toast.success(t('has_been_created_successfully'));
                navigate(routes.foodie.list, {
                    state: {
                        currentTab: TABS_FOODIE.SCHEDULES.INDEX,
                        currentSubView: SUB_VIEW_MODEL.SCHEDULE.SHIFTS
                    }
                });
            } else errorMsg(code);
        });
    }

    return {
        id,
        t,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        cafeterias, setCafeterias,
        selectDeleteCafeterias, setSelectDeleteCafeterias,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,

        user, setUser,
        selectDeleteUser, setSelectDeleteUser,

        steps,
        activeStep, setActiveStep,
        searchElement, setSearchElement,
        modified, setModified,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleAddEdit,
        handleOnBack,
    }
}
